import Entry from "./Entry";

function ImagesDD({ entries, active, updateFilterValue, selectedInps, setActive }) {
  return (
    <div className={"filter-panel pattern " + (active ? "active" : "")}>
      {entries.map((entry) =>
        <Entry
          image={entry.image}
          name={entry.name}
          value={entry.value}
          updateFilterValue={updateFilterValue}
          key={entry.name}
          selectedInps={selectedInps}
          removeActive={() => setActive(false)}
        />
      )
      }
    </div >
  );
}

export default ImagesDD